import '@grandvisionhq/utils';
import { getUnlocalizedSpecificationItem } from '../utils/get-unlocalized-specification-item.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';
import { mapServerToSpecificationsBase } from './map-server-to-specifications-base.js';
import { getSharedFrameSpecificationItems } from './shared/get-shared-frame-specification-items.js';

const mapServerToReadyReaderSpecifications = (serverVariant, brand, prescriptionGlass)=>{
    const { targetGender , targetGenderAllLocales , lensFeatures , frameFeatures  } = serverVariant.variantTypeDetails;
    const genderUnlocalized = getUnlocalizedSpecificationItem(targetGenderAllLocales);
    return [
        ...mapServerToSpecificationsBase(serverVariant, brand),
        ...getSpecificationItems({
            targetGender,
            genderUnlocalized
        }),
        ...getSharedFrameSpecificationItems({
            lensFeatures,
            frameFeatures,
            prescriptionGlass
        }), 
    ];
};

export { mapServerToReadyReaderSpecifications };
//# sourceMappingURL=map-server-to-ready-reader-specifications.js.map
